import TreeSelect from './treeSelect.vue';

export default TreeSelect;
